/**
 * Canonical destinations for workflows that are reachable from more than one
 * operational surface. Keep context in the URL so a handoff does not make an
 * operator choose the event again.
 */
export function getKidsCheckInPath(eventId?: string | null) {
  if (!eventId) return "/kids-check-in";

  return `/kids-check-in?${new URLSearchParams({ eventId, mode: "check-out" }).toString()}`;
}

export type PickupHandoff =
  | { kind: "kids-check-in"; path: string }
  | { kind: "legacy" }
  | { kind: "none" };

export function resolvePickupHandoff({
  eventId,
  kidsCheckInAvailable,
  hasUnmigratedLegacyCode,
  isChildPickupContext,
}: {
  eventId?: string | null;
  kidsCheckInAvailable: boolean;
  hasUnmigratedLegacyCode: boolean;
  isChildPickupContext: boolean;
}): PickupHandoff {
  if (!isChildPickupContext) {
    return { kind: "none" };
  }

  if (!eventId || !kidsCheckInAvailable || hasUnmigratedLegacyCode) {
    return { kind: "legacy" };
  }

  return { kind: "kids-check-in", path: getKidsCheckInPath(eventId) };
}

export const contributionImportPath = "/contributions/import";
